import { updateOptions as updateOptionsAction } from 'app/store/reducers/general';
import { ThunkType } from 'app/hooks/appHooks';
import { brandNameSelector, optionsSelector } from 'app/store/selectors';
import { getIsGlobalTripSearch, SearchMaskMountOptions } from '@webc/meeseeks-ui-sdk';
import { shopUrls } from 'app/config/shopUrls';
import { getQueryString, getSearchMaskValuesFromQueryString, redirectToUrl } from 'app/functions';
import { updateSearchMaskValues } from 'app/store/thunk/general/updateSearchMaskThunk';
import { loadUI } from 'app/store/reducers/ui';
import { StoreGeneralField } from 'app/models/types/store/general';
import { requestTranslations } from 'app/store/thunk/general/requestTranslationsThunk';
import { getLocaleForGlobalTrips } from 'app/functions/general/getLocaleForGlobalTrips';
import { setDepartureDate } from 'app/store/reducers/date';
import { getUnixTime } from 'date-fns';

export const updateOptions =
  (options: StoreGeneralField['options']): ThunkType<void> =>
  async (dispatch, getState) => {
    dispatch(updateOptionsAction(options));

    const state = getState();
    const oldOptions: ReturnType<typeof optionsSelector> = optionsSelector(state);
    const brand: ReturnType<typeof brandNameSelector> = brandNameSelector(state);
    const newOptions: SearchMaskMountOptions = { ...oldOptions, ...options };
    const isGlobalTripSearch = getIsGlobalTripSearch({
      locale: newOptions.locale,
      departureCountryCode: newOptions.initialSearchMaskValues.departureCountryCode,
      arrivalCountryCode: newOptions.initialSearchMaskValues.arrivalCountryCode,
    });

    // Hack to set a specific departure date for Australia locale, should be removed after 20th Nov 2025
    const RIDES_AVAILABLE_DATE_AU = new Date('2025-11-20');
    const AU_LOCALE = 'en_AU';
    if (newOptions.locale === AU_LOCALE && new Date() <= RIDES_AVAILABLE_DATE_AU) {
      dispatch(setDepartureDate({ date: getUnixTime(RIDES_AVAILABLE_DATE_AU) }));
    }

    if (isGlobalTripSearch) {
      const redirectLocale = getLocaleForGlobalTrips(newOptions.locale);
      const host = shopUrls[brand]?.[redirectLocale]
        ? shopUrls[brand][redirectLocale]
        : shopUrls['flixbus'][redirectLocale];
      const path = 'search';
      const queryString = getQueryString();
      const urlToRedirectTo = `${window.location.protocol}//${host}/${path}${queryString}&_locale=${redirectLocale}&isGlobalTripSearch=1`;
      redirectToUrl(urlToRedirectTo);
      return null;
    }

    const searchMaskValues = {
      ...options?.initialSearchMaskValues,
      ...getSearchMaskValuesFromQueryString(getQueryString()),
    } as SearchMaskMountOptions['initialSearchMaskValues'];

    await dispatch(updateSearchMaskValues(searchMaskValues));
    await dispatch(requestTranslations(newOptions.locale));
    dispatch(loadUI());
  };
